import React, { useState } from 'react';
import { CgAdd } from 'react-icons/cg';

const InputTodo = ({ addTodo }) => {
  const [inputText, setInputText] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const onChange = (e) => {
    setErrorMessage('');
    setInputText(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim()) {
      addTodo(inputText);
      setInputText('');
    } else {
      setErrorMessage('Please write a Todo item');
    }
  };

  const errMsg = {
    color: 'red',
    fontSize: 'small',
    height: '20px',
    display: 'block',
    marginLeft: '20px',
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="form-container">
        <input
          type="text"
          className="input-text"
          placeholder="Add todo..."
          value={inputText}
          name="title"
          onChange={onChange}
        />
        <button aria-label="Add icon" type="submit" className="input-submit"><CgAdd /></button>
      </form>
      <span style={errMsg}>{errorMessage}</span>
    </>
  );
};

export default InputTodo;
